import { Box, Button } from "@modernatx-internal/component-library";
import React from "react";

import { useFinder } from "@/finder/hooks/V2/useFinder";
import type { FinderLocation } from "@/types/FinderLocation";

import { CallButton } from "./CallButton";
import { LocationDetails } from "./LocationDetails";
import { ProductAvailability } from "./ProductAvailability";
import { ScheduleNowButton } from "./ScheduleNowButton";

export const FinderListResult = ({
  location,
  setRef
}: {
  location: FinderLocation;
  setRef: (el: HTMLElement | null) => void;
}) => {
  const {
    country,
    locationSelected,
    locationSelectedSet,
    resultsView,
    isMobile,
    locationHoveredSet
  } = useFinder();

  const JpWebsiteButton = ({ url }: { url: string | undefined }) => {
    return url ? (
      <Button
        sx={{ verticalAlign: "top" }}
        variant={isMobile ? "filled" : "outline"}
        icon="arrow-right"
        iconPosition="end"
        href={url}
      >
        WEB サイト
      </Button>
    ) : null;
  };

  return (
    <Box
      ref={setRef}
      sx={{
        backgroundColor: () =>
          locationSelected === location && resultsView !== "mobileMap" ? "#F5F5F6" : "white",
        borderBottom: "1px solid",
        borderColor: "stroke-neutral-secondary",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        transition: "transition-ease-out-fast",
        p: 3,
        pl: 6,
        ":last-child": {
          borderBottom: "none"
        },
        ":hover": {
          backgroundColor: () => (resultsView !== "mobileMap" ? "#F5F5F6" : "white")
        }
      }}
      onClick={() => {
        locationSelectedSet(location);
      }}
      onMouseEnter={() => {
        locationHoveredSet(location);
      }}
      onMouseLeave={() => {
        locationHoveredSet(null);
      }}
    >
      <LocationDetails location={location} />
      <ProductAvailability productsAtLocation={location.products} />
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        {isMobile && <CallButton location={location} />}
        {country !== "jp" ? (
          <ScheduleNowButton location={location} />
        ) : (
          <JpWebsiteButton url={location.customer.website || ""} />
        )}
      </Box>
    </Box>
  );
};
